import Swiper from 'swiper';
import MicroModal from 'micromodal';

(function (window, document) {
  'use strict';
  MicroModal.init({
    disableScroll: true,
  });
  const _application = {
    bp: {
      lg: 1024,
      md: 768
    }
  };
  const mql = {
    lg: window.matchMedia(`(min-width:${_application.bp.lg / 16}rem)`),
    md: window.matchMedia(`(min-width:${_application.bp.md / 16}rem)`)
  };
  const modules = {
    homeSlider: () => {
      const homeMvElm = document.querySelector('.js-mv-swiper');
      if (!homeMvElm) return;

      let carousel;
      const $swiperContainer = homeMvElm.querySelector('.swiper-container') as HTMLElement;
      if (!$swiperContainer) return;
      const navigationConfig = {
        nextEl: homeMvElm.querySelector('.swiper-button-next') as HTMLElement,
        prevEl: homeMvElm.querySelector('.swiper-button-prev') as HTMLElement
      };
      const paginationConfig = {
        el: homeMvElm.querySelector('.swiper-pagination') as HTMLElement
      };
      const settings = {
        pc: {
          autoplay: {
            delay: 5000
          },
          navigation: navigationConfig,
          pagination: paginationConfig,
          spaceBetween: 24,
          slidesPerView: 2,
          centeredSlides: true,
          loop: true,
        },
        sp: {
          autoplay: {
            delay: 5000
          },
          navigation: navigationConfig,
          pagination: paginationConfig,
          spaceBetween: 0,
          slidesPerView: 1,
          loop: true,
          centeredSlides: true,
        }
      };
      // const slideCount = homeMvElm.querySelectorAll('.swiper-slide').length;
      // slide数が2未満でloopをfalseに
      // if (slideCount < 2) {
      //   settings.pc.loop = false;
      //   settings.sp.loop = false;
      //   navigationConfig.nextEl.style.display = 'none';
      //   navigationConfig.prevEl.style.display = 'none';
      //   paginationConfig.el.style.display = 'none';
      // }
      const initializeSwiper = ($mql) => {
        if (carousel) {
          carousel.destroy(carousel);
          carousel = null;
        }
        if ($mql.matches) {
          carousel = new Swiper($swiperContainer, settings.pc);
        } else {
          carousel = new Swiper($swiperContainer, settings.sp);
        }
      };
      initializeSwiper(mql.md);
      mql.md.addListener(initializeSwiper);
    },
    itemDetailSlider: () => {
      const itemDetailSliderElm = document.querySelector('.js-itemDetailSlider-swiper');
      if (!itemDetailSliderElm) return;

      let carousel;
      const $swiperContainer = itemDetailSliderElm.querySelector('.swiper-container') as HTMLElement;
      if (!$swiperContainer) return;
      const navigationConfig = {
        nextEl: itemDetailSliderElm.querySelector('.swiper-button-next') as HTMLElement,
        prevEl: itemDetailSliderElm.querySelector('.swiper-button-prev') as HTMLElement
      };
      const paginationConfig = {
        el: itemDetailSliderElm.querySelector('.swiper-pagination') as HTMLElement
      };
      const settings = {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: navigationConfig,
        pagination: paginationConfig
      }
      if (carousel) {
        carousel.destroy(carousel);
        carousel = null;
      }
      carousel = new Swiper($swiperContainer, settings);
    },
    headerNav: () => {
      var addClassName = 'is-open';
      var triggerHeaderElm = document.querySelector('.js-header-hamburger-button'); 
      var triggerHeaderWrapperElm = document.querySelector('.js-hamburger-wrapper'); 
      var targetElm = document.querySelector('.js-menu-target'); // 1つの要素
      var headerRoot = document.querySelector('.js-header');
      var childNavToggleButtons = document.querySelectorAll('.js-nav-child-menu-toggle-button'); // 複数の要素
      const bodyElement = document.body;
      if (!triggerHeaderWrapperElm) return;
    
      var toggleClassHandle = (trigger) => {
        trigger.addEventListener('click', () => {
          triggerHeaderElm.classList.toggle(addClassName);
          triggerHeaderWrapperElm.classList.toggle(addClassName);
          targetElm.classList.toggle(addClassName); // 1つの要素に対するトグル
          headerRoot.classList.toggle(addClassName);
          if (bodyElement && bodyElement.style.overflowY !== "hidden") {
            bodyElement.style.overflowY = "hidden";
          } else {
            bodyElement.style.overflowY = "initial";
          }
        });
      };
    
      var toggleChildClassHandle = () => {
        childNavToggleButtons.forEach(button => { // 複数のボタンに対するトグル
          button.addEventListener('click', () => {
            button.classList.toggle(addClassName);
          });
        });
      };
    
      const init = ($mql) => {
        if ($mql.matches) {
        } else {
          toggleClassHandle(triggerHeaderWrapperElm);
          toggleChildClassHandle(); // 更新された関数呼び出し
        }
      };
      init(mql.md);
      mql.md.addListener(init);
    },
    modalSearchBoxResponsive: () => {
      var addClassName = 'is-open';
      const modalSearchTriggerList = document.querySelectorAll(".js-modalSearch-box-trigger");
      const initPC = () => {
        modalSearchTriggerList.forEach((item) => {
          item.classList.remove(addClassName);
        });
      }
      const initSP = () => {
        modalSearchTriggerList.forEach((item) => {
          item.addEventListener('click', () => {
            item.classList.toggle(addClassName);
          });
        });
      }
      const init = ($mql) => {
        if ($mql.matches) {
          initPC();
        } else {
          initSP();
        }
      };
      init(mql.lg);
      mql.lg.addListener(init);
    },
    amountChangeButton: () => {
      const amountChangeEl = document.querySelectorAll(".js-amount-change");
      amountChangeEl.forEach((item) => {
        const minusButton = item.querySelector('.js-amount-change-minus') as HTMLButtonElement;
        const plusButton = item.querySelector('.js-amount-change-plus') as HTMLButtonElement;
        const inputEl = item.querySelector('.js-amount-change-input') as HTMLInputElement;
        if(!minusButton || !plusButton || !inputEl) return;
        const setButtonAble = () => {
          if(inputEl.valueAsNumber === 0) {
            minusButton.disabled = true;
          } else {
            minusButton.disabled = false;
          }
        }
        plusButton.addEventListener('click', () => {
          inputEl.valueAsNumber = inputEl.valueAsNumber + 1;
          setButtonAble();
        });
        minusButton.addEventListener('click', () => {
          inputEl.valueAsNumber = inputEl.valueAsNumber - 1;
          setButtonAble();
        });
        inputEl.addEventListener('input', () => {
          setButtonAble();
        });
      });
    },
    scrollOffset: () => {
  document.addEventListener("DOMContentLoaded", function() {
    // 固定ヘッダーの高さを取得
    var header = document.querySelector('.js-header') as HTMLElement;
    var headerHeight = header ? header.offsetHeight : 0;

    // アンカーリンクがクリックされた時の処理
    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function(anchor) {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        var targetId = this.getAttribute('href').substring(1);
        var target = document.getElementById(targetId);

        if (target) {
          var targetOffset = target.getBoundingClientRect().top + window.scrollY;
          var scrollToPosition = targetOffset - headerHeight;

          window.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  });
    }
  }
  modules.homeSlider();
  modules.headerNav();
  modules.itemDetailSlider();
  modules.modalSearchBoxResponsive();
  modules.amountChangeButton();
  modules.scrollOffset();

})(window, document);
